export default "__VITE_ASSET__bAYDn2jB__"